import React from "react";
import {useSelector} from "react-redux";

const StoreHeader = () => {
  const {store} = useSelector((state) => {
    return {
      store: state.store || null,
    };
  });

  return (
    <div className="w-full bg-[#FEFEFF] border-b border-[#DDDDDD] py-4 px-4">
      <p className="text-[#666666] text-xs font-medium mb-1">Estás en:</p>
      <p className="text-[#343E49] text-base font-semibold">
        {store.storeName}
      </p>
    </div>
  );
};

export default StoreHeader;
